import axiosCall from './interceptor';
import URL from '../helper';

export const addTemplateTags = async data => {
  const url = `${URL.BASE_URL}template `;
  let form = new FormData();
  form.append('id', data.id);
  form.append('tags', data.tags);
  let response = await axiosCall('patch', url, form);
  return response.data;
};

export const addElementTags = async data => {
  const url = `${URL.BASE_URL}element`;
  let form = new FormData();
  form.append('id', data.id);
  form.append('tags', data.tags);
  // form.append('elementType', data.elementType);
  let response = await axiosCall('patch', url, form);
  return response.data;
};

//////mail//////////

export const addMailTemplateTags = async data => {
  const url = `${URL.BASE_URL}saveMailTemplateDraft?id=${data.id}&tags=${data.tags}`;
  let response = await axiosCall('patch', url);
  return response.data;
};

export const addMailElementTags = async data => {
  const url = `${URL.BASE_URL}updateElement `;
  let response = await axiosCall('put', url, data);
  return response.data;
};

export const addShortMessageTags = async data => {
  const url = `${URL.BASE_URL}message `;
  let form = new FormData();
  form.append('id', data.id);
  form.append('tags', data.tags);
  let response = await axiosCall('patch', url, form);
  return response.data;
};